import React from 'react'
import { useSelector } from 'react-redux'
import USTemplateDefault from 'src/components/template/us'
import { selectParams } from 'src/modules/reducers/params'
import { promoCodes } from 'src/constants/promoCodes'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'
export default (props) => {
  const params = useSelector(selectParams)

  // Check referrer for valid visitor from capitaloneoffers.com
  const [validReferrer, setValidReferrer] = React.useState(false)
  React.useEffect(() => {
    if (params?.irmp === '101044') {
      setValidReferrer(true)
    }
  }, [params])

  const offerBanner = validReferrer
    ? {
        title: [
          'Special offer for Capital One Members',
          'Save $20 off the first two months of Fubo Pro when you sign up with a Capital One Card',
        ],
      }
    : {
        title: [
          'Offer Not Applied.',
          'Please revisit this page from the offer on the Capital One website.',
        ],
        showIcon: false,
      }

  const miceText = validReferrer
    ? '*Offer applies to first-time Fubo subscribers who sign up for a subscription using a Capital One card associated with this offer. Offer valid one time only.'
    : false

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      miceText={miceText}
      offerCode={validReferrer ? promoCodes.capital_one : null}
      offerBanner={offerBanner}
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      showRSN={true}
      noIndex={true}
    />
  )
}
